import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { map } from 'rxjs/operators';
import { StoreSummaryService } from './store-summary.service';
import { ElementRef, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { FormChangeService } from '../services/form-change.service';
import { ZonesService } from '../zones/zones.service';
import * as moment from 'moment';
import { ParkingService } from '../services/parking.service';
@Component({
  selector: "app-dash",
  templateUrl: "./dash.component.html",
  styleUrls: ["./dash.component.scss"],
})
export class DashComponent implements OnInit {
  realTimeStatData;
  statData;
  totalBusy = 0;
  totalEmpty = 0;

  //stacked bar chart data and options
  stackedBarDataType= "T";
  zones;
  places;
  
  stackedBarPlaceData ;
  stackedBarZoneData ;
  stackedBaroptions = {
    legend: {
      display: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          display: true,
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };

  chartColors = {
    red: "rgb(255, 99, 132)",
    orange: "rgb(255, 159, 64)",
    yellow: "rgb(255, 205, 86)",
    green: "rgb(75, 192, 192)",
    blue: "rgb(54, 162, 235)",
    purple: "rgb(153, 102, 255)",
    grey: "rgb(201, 203, 207)",
  };

  mutiLineChartDataPlaces;
  mutiLineChartDataZones;
  mutiLineChartDataZonesType;
  position = "bottom";
  mutiLineChartDataoptions = {
    responsive: true,
    title: {
      display: true,
      text: "Tooltip Position: " + this.position,
    },
  };
  cardLayout;
  miniCardData;
  selectedChart;
  @ViewChild("charts") public chartsRef: ElementRef;

  public salesChartLabels: Label[] = [];

  constructor(
    private breakpointObserver: BreakpointObserver,
    service: StoreSummaryService,
    private formServ: FormChangeService,
    private ZoneServ: ZonesService,
    private placeServ: ParkingService,
  ) {
    this.cardLayout = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
      map(({ matches }) => {
        if (matches) {
          return {
            columns: 1,
            miniCard: { cols: 1, rows: 1 },
            chart: { cols: 1, rows: 2 },
          };
        }
        return {
          columns: 4,
          miniCard: { cols: 1, rows: 1 },
          chart: { cols: 2, rows: 2 },
        };
      })
    );
  }
  getMiniCardData(){
    let nbPlaceBusy = 0;
    let nbPlaceEmpty = 0;
    let txOccupation = 0;
    let nbParkForDay = 0;
    if(this.realTimeStatData){
      nbPlaceBusy = this.realTimeStatData.stats.nbPlaceBusy?this.realTimeStatData.stats.nbPlaceBusy: 0;
      nbPlaceEmpty = this.realTimeStatData.stats.nbPlaceEmpty?this.realTimeStatData.stats.nbPlaceEmpty: 0;
      txOccupation = this.realTimeStatData.stats.txOccupation?this.realTimeStatData.stats.txOccupation: 0;
      nbParkForDay = this.realTimeStatData.stats.nbParkForDay?this.realTimeStatData.stats.nbParkForDay: 0;
    }
      return [{ title: "Occupé", value: nbPlaceBusy, isIncrease: true, color: "primary", icon:"garage",subtitle:"Nbr de place acctuellement occupée" },
      { title: "Libre", value: nbPlaceEmpty, isIncrease: false, color: "accent",icon: "local_parking", subtitle:"Nbr de place acctuellement libre"},
      { title: "Utilisation", value: nbParkForDay, isIncrease: true, color: "warn", icon:"swap_vert", subtitle:"Nbr d'utilisation journalière" },
      { title: "Taux OC", value:txOccupation, isPercent: false, color: "primary", icon:"percent", subtitle:"Taux d'occupation" }];

  }
  focusChart(event) {
    this.selectedChart = event.currentTarget.id;
    let charts = $(event.currentTarget).siblings(".chart");
  }
  ngOnInit() {
    this.formServ.formDashRealTimeStatSearchEvent.subscribe((data) => {
      this.realTimeStatData = data[0];
      this.ZoneServ.getZones().subscribe(
        data =>{
          this.zones = data as Array<any>;
          this.mutiLineChartDataZonesType = this.zones[0].id;
          this.loadStackedBarZoneData()
          this.loadStackedBarPlaceData();
        });
      });
      
    this.placeServ.getMyPlacesById().subscribe(
      (data) =>{
        this.places = data as Array<any>;
        
      });
        //Traitement de stats historique
    this.formServ.formDashStatSearchEvent.subscribe(
      (data) => {
      this.statData = data;
      this.fillZoneHistoriqueGraph();
      this.fillPlaceHistoriqueGraph();
    },
    (error) =>{
      console.log("ici");
    });
} 
  private fillPlaceHistoriqueGraph() {
    let labels = [];
    let dataSetLabels = ["Libre", "Occupé"];
    let dataSetEmptyData = [];
    let dataSetBusyData = [];
    this.statData.forEach(stat => {
      labels.push(moment(stat.date).format("DD/MM/YYYY HH:MM"));
      dataSetEmptyData.push(stat.stats.nbPlaceEmpty);
      dataSetBusyData.push(stat.stats.nbPlaceBusy);
    });
    this.statData = this.statData.sort((el1, el2) => {
      return moment(el1.date).diff(moment(el2.date));
    });
    this.mutiLineChartDataPlaces = {
      labels: labels,
      datasets: [
        {
          label: dataSetLabels[0],
          borderColor: this.chartColors.red,
          backgroundColor: this.chartColors.red,
          data: dataSetEmptyData,
          fill: false,
        },
        {
          label: dataSetLabels[1],
          borderColor: this.chartColors.blue,
          backgroundColor: this.chartColors.blue,
          data: dataSetBusyData,
          fill: false,
        },
      ],
    };
  }

  public  fillZoneHistoriqueGraph() {
    let labels =[];
    let dataSetLabels = ["Libre", "Occupé"];
    let dataSetEmptyData= [];
    let dataSetBusyData= [];
    this.mutiLineChartDataZonesType;
    this.statData.forEach(stat => {
      labels.push(moment(stat.date).format("DD/MM/YYYY HH:MM"));
      let emptyVal = 0;
      let busyVal = 0;
      if(stat.stats.nbEmptyByZoneMap && stat.stats.nbEmptyByZoneMap[this.mutiLineChartDataZonesType]){
        emptyVal = stat.stats.nbEmptyByZoneMap[this.mutiLineChartDataZonesType]
      }
      if(stat.stats.nbBusyByZoneMap && stat.stats.nbBusyByZoneMap[this.mutiLineChartDataZonesType]){
        busyVal = stat.stats.nbBusyByZoneMap[this.mutiLineChartDataZonesType]
      }
      dataSetEmptyData.push(emptyVal);
      dataSetBusyData.push(busyVal);
    });
    this.mutiLineChartDataZones = {
      labels: labels,
      datasets: [
        {
          label: dataSetLabels[0],
          borderColor: this.chartColors.red,
          backgroundColor: this.chartColors.red,
          data: dataSetEmptyData,
          fill: false,
        },
        {
          label: dataSetLabels[1],
          borderColor: this.chartColors.blue,
          backgroundColor: this.chartColors.blue,
          data: dataSetBusyData,
          fill: false,
        },
      ],
    };
  }

loadStackedBarZoneData(){
      let nbBusyByZoneMap = this.realTimeStatData.stats.nbBusyByZoneMap;
      let nbEmptyByZoneMap = this.realTimeStatData.stats.nbEmptyByZoneMap;
      debugger;
      let datasets = [];
          this.zones.forEach((zone, index) => {
            let data = [];
            let zonePresent = false;
            if(nbBusyByZoneMap[zone.id]){
              data.push(nbBusyByZoneMap[zone.id])
              zonePresent = true;
            }
            if(nbEmptyByZoneMap[zone.id]){
              if(zonePresent == false){
                data.push(null);
              }
              data.push(nbEmptyByZoneMap[zone.id])
              zonePresent = true;
            } else {
              if(zonePresent){
                data.push(null);
              }
            }
          if(zonePresent){
              datasets.push(
              {
                label: zone.label,
                fill:'true',
                backgroundColor: '#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6),
                data: data
              }
            )
          }
        })
          this.stackedBarZoneData = {
            labels: ["Occupé", "Libre"],
          datasets: datasets
        }
}
  loadStackedBarPlaceData(){
      let nbBusyByTypeMap = this.realTimeStatData.stats.nbBusyByTypeMap;
      let nbEmptyByTypeMap = this.realTimeStatData.stats.nbEmptyByTypeMap;
      this.stackedBarPlaceData = {
          labels: ['Delivering',"Free","PMR","Paying","Private","Resident"],
        datasets: [
          {
            label: "Libre",
            fill:'true',
            backgroundColor: '#ff0266',
            data: [
              nbEmptyByTypeMap.Delivering?nbEmptyByTypeMap.Delivering:null,
              nbEmptyByTypeMap.Free?nbEmptyByTypeMap.Free:null,
              nbEmptyByTypeMap.PMR?nbEmptyByTypeMap.PMR:null,
              nbEmptyByTypeMap.Paying?nbEmptyByTypeMap.Paying:null,
              nbEmptyByTypeMap.Private?nbEmptyByTypeMap.Private:null,
              nbEmptyByTypeMap.Resident?nbEmptyByTypeMap.Resident:null,
            ]
          },{
            label: "Ocuppée",
            fill:'true',
            backgroundColor: '#81c784',
            data:[
              nbBusyByTypeMap.Delivering?nbBusyByTypeMap.Delivering:null,
              nbBusyByTypeMap.Free?nbBusyByTypeMap.Free:null,
              nbBusyByTypeMap.PMR?nbBusyByTypeMap.PMR:null,
              nbBusyByTypeMap.Paying?nbBusyByTypeMap.Paying:null,
              nbBusyByTypeMap.Private?nbBusyByTypeMap.Private:null,
              nbBusyByTypeMap.Resident?nbBusyByTypeMap.Resident:null,
            ]
          }
        ]
        };
  }
}
